angular.module('meanApp')

.controller('personal-info-controller', function(/*$scope*/) {
  'use strict';
});
